module.exports = __webpack_public_path__ + "img/c_v4.7a118ad.png";